export default "__VITE_ASSET__O5kEc161__"